import { render, staticRenderFns } from "./SidebarCookies.vue?vue&type=template&id=6b839ac4&"
import script from "./SidebarCookies.vue?vue&type=script&lang=js&"
export * from "./SidebarCookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports